<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-06-12 11:12:59
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<!--
Author: TangChen
Date: 2018-10-17
Desc: 找回交易密码，由index.js 配置引入
 -->
<template>
    <div class="bizcomp-reset-tpwd">
        <reset-pwd :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import resetPwd from "@/components/acctInfo/resetPwdDc.vue";
export default {
    name: "Resettpwd",
    components: {
        resetPwd
    },
    mixins: [mixin],
    data() {
        return {
            way: "trade"
        };
    },
    methods: {
        // 账户绑定选项处理
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-reset-tpwd {
}
</style>
